import axios from "axios";
import { buildWebStorage, setupCache } from "axios-cache-interceptor";

const { url } = window.__REACT_WORDPRESS__.routing;

const ajaxCache =
  typeof __IS_DEV__ === "undefined"
    ? {
        storage: buildWebStorage(sessionStorage, "main-cache:"),
      }
    : {};

const ajax = setupCache(
  axios.create({
    baseURL: `${url}/wp-json/wp/v2/`,
  }),
  ajaxCache
);

const acfAjaxCache =
  typeof __IS_DEV__ === "undefined"
    ? {
        storage: buildWebStorage(sessionStorage, "acf-cache:"),
      }
    : {};

const acfAjax = setupCache(
  axios.create({
    baseURL: `${url}/wp-json/acf/v3/`,
  }),
  acfAjaxCache
);

const searchAjaxCache =
  typeof __IS_DEV__ === "undefined"
    ? {
        storage: buildWebStorage(sessionStorage, "search-cache:"),
      }
    : {};

const searchAjax = setupCache(
  axios.create({
    baseURL: `${url}/wp-json/swp_api/search?s=`,
  }),
  searchAjaxCache
);

const batchRequest = {};

function addBatchId(type, id, embed) {
  if (!batchRequest[type]) {
    batchRequest[type] = {};
    batchRequest[type].ids = [id];
    batchRequest[type].request = new Promise((resolve) => {
      setTimeout(() => {
        resolve(batchRequestIds(type, embed));
        batchRequest[type] = null;
      }, 100);
    });
  } else if (!batchRequest[type].ids.includes(id)) {
    batchRequest[type].ids.push(id);
  }
}

function batchRequestIds(type, embed) {
  if (embed) {
    return ajax.get(`/${type}/`, {
      params: { include: batchRequest[type].ids, per_page: 100, _embed: true },
    });
  } else {
    return ajax.get(`/${type}/`, {
      params: { include: batchRequest[type].ids, per_page: 100 },
    });
  }
}

export const fetchSingleById = ({ type, id, batch = false, embed = false }) => {
  if (batch) {
    addBatchId(type, id, embed);
    return batchRequest[type].request;
  } else {
    return ajax.get(`/${type}/${id}${embed ? "?_embed" : ""}`);
  }
};

export const fetchSingle = ({ type, params = {} }) => {
  return ajax.get(`/${type}/`, { params });
};

export const fetchItems = ({ type, params = {} }) => {
  return ajax.get(`/${type}/`, { params });
};

export const fetchSearch = ({ term, params = {} }) => {
  return searchAjax.get(`/${term}/`, { params });
};

export const fetchAcfOptions = () => {
  return acfAjax.get("/options/options");
};

export const fetchHomePage = () => {
  return ajax.get("/frontpage");
};

// Keep the parent's identity and overlay revision fields, including formatted
// ACF metadata. Both requests use the wp_rest nonce, not the preview-link nonce.
export const fetchPreviewItem = async ({ restBase, id, nonce, autosaveId }) => {
  const config = {
    headers: { "X-WP-Nonce": nonce },
    params: { context: "edit" },
    cache: false,
  };
  const response = await ajax.get(`/${restBase}/${id}`, config);
  if (!autosaveId) return response;

  const { data: autosave } = await ajax.get(`/${restBase}/${id}/autosaves/${autosaveId}`, config);
  if (Number(autosave.parent) !== Number(id)) {
    throw new Error("Preview autosave does not belong to this post");
  }

  const post = { ...response.data };
  for (const field of ["title", "content", "excerpt"]) {
    if (autosave[field] !== undefined) {
      post[field] = { ...post[field], ...autosave[field] };
    }
  }
  if (autosave.acf && typeof autosave.acf === "object") {
    post.acf = { ...post.acf, ...autosave.acf };
  }
  return { ...response, data: post };
};

export const fetchSideBar = ({ name, params = {} }) => {
  return ajax.get(`/${name}/`, { params });
};
